import { useEffect, useState, useRef } from "react";
import axios from "axios";
import API_BASE_URL from "../config";
import "../styles/MaintenanceNoticeSlider.css";

export default function MaintenanceNoticeSlider() {

    const [items, setItems] = useState([]);
    const [index, setIndex] = useState(0);
    const [closed, setClosed] = useState(false);

    // 🔁 used to schedule auto reload
    const reloadTimerRef = useRef(null);

    const formatIST = (utcString) => {
        if (!utcString) return "";

        return new Date(utcString).toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
        });
    };

    const loadMaintenance = async () => {
        try {
            const res = await axios.get(`${API_BASE_URL}/api/maintenance`);
            const data = res.data?.data || [];

            // only Scheduled items for slider
            const scheduledOnly = data
                .filter((i) => i.status === "Scheduled")
                .sort((a, b) => new Date(a.startTime) - new Date(b.startTime));

            setItems(scheduledOnly);
            setIndex(0);

            // ---------------------------------------
            // ✅ Auto reload when scheduled time starts
            // ---------------------------------------
            if (reloadTimerRef.current) {
                clearTimeout(reloadTimerRef.current);
                reloadTimerRef.current = null;
            }

            const now = Date.now();

            const upcoming = scheduledOnly.find(
                (m) => new Date(m.startTime).getTime() > now
            );

            if (upcoming) {
                const startAt = new Date(upcoming.startTime).getTime();
                const delay = startAt - now;

                if (delay > 0) {
                    reloadTimerRef.current = setTimeout(() => {
                        window.location.reload();
                    }, delay);
                }
            }

        } catch (err) {
            console.error("Maintenance slider load failed", err);
        }
    };

    useEffect(() => {
        loadMaintenance();

        const t = setInterval(loadMaintenance, 60000);

        return () => {
            clearInterval(t);

            if (reloadTimerRef.current) {
                clearTimeout(reloadTimerRef.current);
            }
        };
    }, []);

    // temporary close
    if (!items.length || closed) return null;

    const item = items[index];

    const handleNext = () => {
        if (items.length <= 1) return;
        setIndex((p) => (p + 1) % items.length);
    };

    return (
        <div className="maintenance-slider-wrap">

            <button
                className="ms-close-btn"
                onClick={() => setClosed(true)}
                aria-label="Close maintenance notice"
            >
                ✕
            </button>

            <div className="slider-container">
                <div
                    className="maintenance-slider-card slide-left"
                    onAnimationIteration={handleNext}
                >
                    <span className="ms-badge">
                        Upcoming Maintenance
                    </span>

                    <span className="ms-msg">
                        {item.message}
                    </span>

                    <span className="ms-time">
                        Start : {formatIST(item.startTime)}
                    </span>

                    <span className="ms-time">
                        End : {formatIST(item.endTime)}
                    </span>
                </div>
            </div>
        </div>
    );
}
